import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

import { PageLoader } from '../../deprecated/PageLoader'
import { LoaderWrapper } from '../../projectComponents'

export const AbsoluteLoader = ({ isLoading }: { isLoading: boolean }) => {
  const [portalNode, setPortalNode] = useState<HTMLElement | null>(null)

  useEffect(() => {
    setPortalNode(document.body)
  }, [])

  return (
    <>
      {isLoading &&
        portalNode &&
        createPortal(
          <LoaderWrapper>
            <PageLoader />
          </LoaderWrapper>,
          portalNode
        )}
    </>
  )
}
